// extracted by mini-css-extract-plugin
export default {"copyToClipboard":"CopyPageURL_copyToClipboard__XOf-0","showCopiedMsg":"CopyPageURL_showCopiedMsg__XhAQD"};